// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-n_hv","advertDetailServiceList__header":"c-n_hw","advertDetailServiceList__list":"c-n_hx"};